import {gql} from '@apollo/client';

const CREATE_VEHICLE_TYPE = gql`
  mutation createBusType(
    $name: String!
    $fuelType: FuelType!
    $dieselConsumption: FuelConsumption
    $adblueConsumption: Float
    $lngConsumption: Float
    $doubleDecker: Boolean!
    $numberOfTires: Int!
  ) {
    createBusType(
      input: {
        name: $name
        fuelType: $fuelType
        dieselConsumption: $dieselConsumption
        adblueConsumption: $adblueConsumption
        lngConsumption: $lngConsumption
        doubleDecker: $doubleDecker
        numberOfTires: $numberOfTires
      }
    ) {
      id
      name
      fuelType
      dieselConsumption
      adblueConsumption
      lngConsumption
      doubleDecker
      numberOfTires
    }
  }
`;

export default CREATE_VEHICLE_TYPE;
